/*
 * @Author: chenqing
 * @Date: 2023-03-21 11:18:14
 * @LastEditors: chenqing
 * @LastEditTime: 2023-05-05 14:00:28
 * @FilePath: /chaojimaHome/App/assets/scripts/modules/baiduStatistics/index.js
 * @Description:
 */
$(() => {
  //隐藏在线咨询
  // const interval = setInterval(() => {
  //   const $newBridge = $("#newBridge");
  //   if ($newBridge.length > 0) {
  //     $newBridge.hide();
  //     clearInterval(interval);
  //   }
  // }, 100);
  //
  $("#adviceOnline").on("click", (event) => {
    event.preventDefault();
    if (isProduction) {
      $("#newBridge").show();
      $("#nb_invite_ok").trigger("click");
    } else {
      // alert("不是正式环境,没有开启在线咨询");
      toastr.info("不是正式环境,没有开启在线咨询");
    }
  });
});
